import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import {
    LCTCourier,
    PrintFull,
    PrintKitchen,
    PrintDailyClose,
    PrintCourierSummery,
    PrintCourierClose,
    DetailCourrier,
    Login,
    FreshOrders,
    OrderIn,
    Kitchen,
    Tables,
    Categories,
    CategoryWrapper,
    ProductIn,
    Courier,
    Payment,
    Phoneorder,
    Settings,
    Logout,
    Statistics,
    Invoices,
    Denied,
    Admin,
    Knowledge,
    OldFreshOrders,
    OldKitchen
} from "./Components";

import Auth from "../services/api/Auth";
import HOC from "./HOC";

import Footer from "../components/Footer";
import Notifications from "../components/Notifications";

import { hasRole } from "../services/Common";

let auth = Auth.isLogin();

// let settings = defaultSettings

const PrivateRoute = ({ component: Component, ...rest }) => {
    let auth = Auth.isLogin();
    return (
        <Route
            {...rest}
            key={Date.now()}
            render={(props) =>
                auth ? <Component {...rest} {...props} /> : <Redirect to="/login" />
            }
        />
    );
};

/*
let initSettings = (fiteredSettings) => {
    let sett = fiteredSettings[0] && fiteredSettings[0]['value'] || null;
    settings = JSON.parse(sett) || defaultSettings
}

new Promise((resolve, reject) => {
      Config.getConfigs().then((result) => {
          let settings = result.filter(i => i.key == 'epossettings');
           initSettings(settings, () => {
             resolve()
           });
      });
})
*/
/* <PrivateRoute exact path='/courier/' component={ settings.enable_lct_courier != undefined && settings.enable_lct_courier ? LCTCourier : Courier} /> */

class Router extends React.Component{
    render() {
        return <Switch>
            <Route
                exact
                path="/login/"
                component={(props) => (auth ? <Redirect to="/" /> : <Login checkRedirect={this.props.checkRedirect} />)}
            />
            <HOC>
                <Switch>
                    <PrivateRoute
                        exact
                        path="/"
                        component={hasRole("kitchenview_role") ? Kitchen : FreshOrders}
                    />
                    <PrivateRoute exact path="/courier/" component={Courier} />
                    <PrivateRoute exact path="/payment/:cart_id" component={Payment} />
                    <PrivateRoute exact path="/tables/" component={Tables} />
                    <PrivateRoute exact path="/tables/:table_id" component={Tables} />

                    <PrivateRoute exact path="/invoices/" component={Invoices} />
                    <PrivateRoute
                        exact
                        path="/daily-close/"
                        name="daily-close"
                        component={Statistics}
                    />
                    <PrivateRoute
                        exact
                        path="/courrier-close"
                        name="courrier-close"
                        component={Statistics}
                    />
                    <PrivateRoute exact path="/detailed-courrier-close" component={DetailCourrier} />

                    <PrivateRoute
                        name="productin"
                        exact
                        path="/table/:table_id/category/:category_id/product/:product_id/"
                        component={ProductIn}
                    />
                    <PrivateRoute
                        name="productinmod"
                        exact
                        path="/table/:table_id/category/:category_id/product/:product_id/item/:cart_index"
                        component={ProductIn}
                    />
                    <PrivateRoute
                        name="category"
                        component={CategoryWrapper}
                        path="/table/:table_id/**"
                    />

                    <PrivateRoute
                        name="new_item_productin"
                        exact
                        path="/new_item/:order_id/table/:table_id/category/:category_id/product/:product_id/"
                        component={ProductIn}
                    />
                    <PrivateRoute
                        name="new_item_category"
                        component={CategoryWrapper}
                        path="/new_item/:order_id/table/:table_id/**"
                    />

                    {/*<PrivateRoute name="orderitemedit" exact path='/order_item_edit/:order_id/item/:item_id' component={ProductIn} /> */}

                    {!this.props.version.versionCodeString ? (
                        <PrivateRoute exact path="/orders" component={OldFreshOrders} />
                    ) : (
                        <PrivateRoute exact path="/orders/" component={FreshOrders} />
                    )}
                    <PrivateRoute exact path="/orders/:id/" component={OrderIn} />
                    <PrivateRoute exact path="/phone-order/" component={Phoneorder} />
                    <PrivateRoute exact path="/settings/" component={Settings} />
                    {!this.props.version.versionCodeString ? (
                        <PrivateRoute exact path="/kitchen/" component={OldKitchen} />
                    ) : (
                        <PrivateRoute exact path="/kitchen/" component={Kitchen} />
                    )}
                    <PrivateRoute
                        exact
                        path="/admin/"
                        component={() => {
                            return <Admin />;
                        }}
                    />

                    <PrivateRoute
                        exact
                        path="/knowledge/"
                        component={() => {
                            return <Knowledge />;
                        }}
                    />

                    <PrivateRoute exact path="/denied/" component={Denied} />
                    <PrivateRoute exact path="/printing/full/:order_id" component={PrintFull} />
                    <PrivateRoute
                        exact
                        path="/printing/full/parent/:order_parent_id"
                        component={PrintFull}
                    />
                    <PrivateRoute exact path="/printing/kitchen/:order_id" component={PrintKitchen} />
                    <PrivateRoute
                        exact
                        path="/printing/daily_close/:from/:to"
                        component={PrintDailyClose}
                    />
                    <PrivateRoute
                        exact
                        path="/printing/courier_summery/:from/:to/:courier_id"
                        component={PrintCourierSummery}
                    />
                    <PrivateRoute
                        exact
                        path="/printing/courier_close/:from/:to/:courier_ids"
                        component={PrintCourierClose}
                    />

                    <PrivateRoute
                        exact
                        path="/logout/"
                        component={() => {
                            return <Logout />;
                        }}
                    />
                    <PrivateRoute component={FreshOrders} />
                </Switch>

                <Footer />
                <Notifications />
            </HOC>
        </Switch>;
    }
}

export default Router;



// WEBPACK FOOTER //
// ./src/routes/index.js